import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';
import moment from "moment-timezone";

export async function getDiemDanhThuBay(payload: {
  page?: number;
  limit?: number;
  cond?: any;
  donViId?: string;
  ngay?: number;
  thang?: number;
  nam?: number;
}) {
  const { page, limit, donViId, ngay, thang, nam, cond } = payload;
  return axios.get(`${ip3}/diem-danh/diem-danh-thu-7/truong/${donViId}/pageable`, {
    params: {
      page,
      limit,
      cond: {
        ...cond,
        ngay,
        thang,
        nam
      },
    },
  });
}

export async function getAttendanceSaturdayStudent(payload: {
  page?: number;
  limit?: number;
  cond?: any;
  donViId?: string;
  thang?: number;
  nam?: number;
  conId?: string;
}) {
  const { page, limit, cond, donViId,conId, thang, nam } = payload;
  return axios.get(`${ip3}/diem-danh/diem-danh-thu-7/pageable`, {
    params: {
      // page,
      limit,
      cond: {
        ...cond,
        conId,
        thang,
        nam,
        donViId,
      },
    },
  });
}

export async function updateDiemDanhThuBay(payload: { id: string; data: any }) {
  const { id, data } = payload;
  return axios.put(`${ip3}/diem-danh/${id}/update-thoi-gian-diem-danh-thu-7`, data);
}
